import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportScheduleTotalChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		title: "Total Schedules",
		yAxisLabel: "Schedules (Count)"
	} ),

	computed: {
		averageValue() {
			const total = this.items.reduce(
				( acc, item ) => acc + item.stats.schedules.reduce( ( acc2, schedule ) => acc2 + schedule.value, 0 ),
				0
			);

			return parseFloat( ( total / this.items.length ).toFixed( 1 ) );
		},

		barData() {
			if ( this.item ) {
				return [
					this.item.stats.schedules.reduce( ( acc, schedule ) => acc + schedule.value, 0 ),
					this.averageValue
				];
			}

			return this.items.map( item =>
				item.stats.schedules.reduce( ( acc, schedule ) => acc + schedule.value, 0 )
			);
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
